import { FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { useContainerStyles } from "../../_styles/container.styles";
import { DiscountManageDrawer } from "./discount-manageDrawer";
import { discountService } from "../../_services/discount.service";
import moment from "moment";


export function DiscountIndex() {

    const [data, setData] = useState({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'value',
                header: 'Value %',
            },
            {
                accessorKey: 'startDate',
                header: 'Start From',
            },
            {
                accessorKey: 'expiryDate',
                header: 'Expiry Date',
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return discountService.getAll({ ...filter })
            .then(
                json => {
                    setData({ ...json, _value: (json.value + "%"), startDate: moment(json.startDate).format('DD/MM/YYYY'), expiryDate: moment(json.expiryDate).format('DD/MM/YYYY') });
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function onDelete(id: number) {
        setLoading(true);
        return discountService
            .disable(id)
            .then(
                () => {
                    fetchData();
                    toastr.success("Discount Type disabled successfully");
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (

        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Discounts"
                    buttonName="Discount"
                    onClick={() => setSelectedId(0)}
                    actionType="create"
                />

                <Paper>

                    <ValidatorForm onSubmit={fetchData}>

                        <StyledGrid container spacing={2}>

                            <Grid item lg={3} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={filter.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                        </StyledGrid>

                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        onEdit={setSelectedId}
                        filter={filter}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />

                    <DiscountManageDrawer
                        isOpen={selectedId != null}
                        itemId={selectedId}
                        onSave={() => { setSelectedId(null); fetchData(); }}
                        onClose={() => { setSelectedId(null); fetchData(); }}
                    />

                </Paper>

            </div>
        </>


    );

}
